import { Store } from 'ply-config'
import { configuration } from './configuration'
import publishers from './publishers'

const store = new Store([publishers, ...configuration])

export default store
